(function ($) {
    'use strict';

    var prfx = 'acom';
    var settings = acom_app.models.settings
    var helper = acom_app.models.helper

    acom_app.views.Result = Backbone.View.extend({
        tagName: 'li',
        model: acom_app.models.settings,
        template: _.template($("#" + prfx + "-results-template").html()),
        render: function () {
            this.close()
            var html = this.template(this.model.toJSON());
            this.$el.html(html);

            return this;
        },
        close: function () {
          this.$el.html('')
        }
    })
})(jQuery)